/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ index: NonNullable<unknown> }} Video_Export_Magnified_Event_HintInputs */

const en_video_export_magnified_event_hint = /** @type {(inputs: Video_Export_Magnified_Event_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Event ${i?.index} - Click anywhere outside to close`)
};

const fr_video_export_magnified_event_hint = /** @type {(inputs: Video_Export_Magnified_Event_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Evenement ${i?.index} - Cliquez en dehors pour fermer`)
};

const de_video_export_magnified_event_hint = /** @type {(inputs: Video_Export_Magnified_Event_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ereignis ${i?.index} - Klicken Sie irgendwo außerhalb, um es zu schließen`)
};

const it_video_export_magnified_event_hint = /** @type {(inputs: Video_Export_Magnified_Event_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Evento ${i?.index} - Clicca in un punto qualsiasi all'esterno per chiudere`)
};

const ru_video_export_magnified_event_hint = /** @type {(inputs: Video_Export_Magnified_Event_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Событие ${i?.index} - Щелкните в любом месте за пределами окна, чтобы закрыть.`)
};

const es_video_export_magnified_event_hint = /** @type {(inputs: Video_Export_Magnified_Event_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Evento ${i?.index} - Haga clic en cualquier lugar afuera para cerrar`)
};

const zh_cn2_video_export_magnified_event_hint = /** @type {(inputs: Video_Export_Magnified_Event_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`事件 ${i?.index} - 点击外部任意位置关闭`)
};

const ja_video_export_magnified_event_hint = /** @type {(inputs: Video_Export_Magnified_Event_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`イベント ${i?.index} - 外側の任意の場所をクリックすると閉じます`)
};

const hi_video_export_magnified_event_hint = /** @type {(inputs: Video_Export_Magnified_Event_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`इवेंट ${i?.index} - बंद करने के लिए बाहर कहीं भी क्लिक करें`)
};

const pt_pt2_video_export_magnified_event_hint = /** @type {(inputs: Video_Export_Magnified_Event_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Evento ${i?.index} - Clique em qualquer lugar fora para fechar`)
};

/**
* | output |
* | --- |
* | "Event {index} - Click anywhere outside to close" |
*
* @param {Video_Export_Magnified_Event_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_magnified_event_hint = /** @type {((inputs: Video_Export_Magnified_Event_HintInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Magnified_Event_HintInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_magnified_event_hint(inputs)
	if (locale === "de") return de_video_export_magnified_event_hint(inputs)
	if (locale === "it") return it_video_export_magnified_event_hint(inputs)
	if (locale === "ru") return ru_video_export_magnified_event_hint(inputs)
	if (locale === "es") return es_video_export_magnified_event_hint(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_magnified_event_hint(inputs)
	if (locale === "ja") return ja_video_export_magnified_event_hint(inputs)
	if (locale === "hi") return hi_video_export_magnified_event_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_magnified_event_hint(inputs)
	return en_video_export_magnified_event_hint(inputs)
});